import { LABELS_TABLE_LABELS } from './LabelsTable.labels';

export const LABELS_TABLE_ID = 'label-management-labels-table';

export const VALUES_CELL_MAX_VISIBLE = 3;

export const VALUES_MODAL_WIDTH = '480px';

export const LABELS_TABLE_COLUMN_WIDTHS = {
	KEY: '200px',
	DISPLAY_NAME: '200px',
	TYPE: '120px',
	VALUES: '360px',
	ACTIONS: '80px'
} as const;

export const CREATE_BUTTON_COLUMN_WIDTH = '140px';

/** ui-common EvTable: `actions-cell-td` keeps the cell `overflow: visible` so the row menu is not clipped. */
export const EV_TABLE_ACTIONS_CELL_TD_CLASS = 'actions-cell-td';

/** One object per row action: stable `id` for the menu item + user-facing `title` (from labels). */
export const LABEL_ROW_MENU_OPTION = {
	EDIT: {
		id: 'edit',
		title: LABELS_TABLE_LABELS.EDIT_ACTION
	},
	DELETE: {
		id: 'delete',
		title: LABELS_TABLE_LABELS.DELETE_ACTION
	}
} as const;

/** Max custom labels per account (Label Management PRD). */
export const MAX_CUSTOM_LABELS = 2;
